import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'home',
  component: Home
}, {
  path: '/brand',
  name: 'brand',
  component: () => import(/* webpackChunkName: "about" */ '../views/Brand')
}, {
  path: '/store',
  name: 'store',
  component: () => import(/* webpackChunkName: "about" */ '../views/Store')
}, {
  path: '/news',
  name: 'news',
  component: () => import(/* webpackChunkName: "about" */ '../views/News')
}, {
  path: '/jewelry',
  name: 'jewelry',
  component: () => import(/* webpackChunkName: "about" */ '../views/Jewelry')
}, {/* 产品列表 */
  path: '/list/:type/:id',
  name: 'list',
  component: () => import(/* webpackChunkName: "about" */ '../views/List')
}, {/* 产品详情页 */
  path: '/detail/:id',
  name: 'detail',
  component: () => import(/* webpackChunkName: "about" */ '../views/Details')
}, {/* TVC 视频播放页 */
  path: '/tvshow',
  name: 'tvshow',
  component: () => import(/* webpackChunkName: "about" */ '../views/TvShow')
}, {/* 品牌 - 企业资讯、最新活动、时尚资讯 模块详情页 */
  path: '/detailsPage/:id',
  name: 'detailsPage',
  component: () => import(/* webpackChunkName: "about" */ '../views/DetailsPage')
}, {/* 招聘模块 - 职位描述 */
  path: '/jobDesc/:id',
  name: 'jobDesc',
  component: () => import(/* webpackChunkName: "about" */ '../views/JobDesc')
}, {/* 产品查询 */
  path: '/QueryValid',
  name: 'QueryValid',
  component: () => import(/* webpackChunkName: "about" */ '../views/QueryValid')
}, {/* 简介 */
  path: '/introduction',
  name: 'introduction',
  component: () => import(/* webpackChunkName: "about" */ '../views/Introduction')
}, {/* 店铺 */
  path: '/shop',
  name: 'shop',
  component: () => import(/* webpackChunkName: "about" */ '../views/Shop')
}, {/* 会员俱乐部 */
  path: '/vip',
  name: 'vip',
  component: () => import(/* webpackChunkName: "about" */ '../views/Vip')
}, {/* 会员查询 */
  path: '/vipSearch',
  name: 'vipSearch',
  component: () => import(/* webpackChunkName: "about" */ '../views/VipSearch')
}, {/* 招聘 */
  path: '/recruit',
  name: 'recruit',
  component: () => import(/* webpackChunkName: "about" */ '../views/Recruit')
}, {/* 团队 */
  path: '/team',
  name: 'team',
  component: () => import(/* webpackChunkName: "about" */ '../views/Team')
}, {/* 珠宝知识 */
  path: '/knowledge',
  name: 'knowledge',
  component: () => import(/* webpackChunkName: "about" */ '../views/Knowledge')
}, {/* 售后服务 */
  path: '/afterSale',
  name: 'afterSale',
  component: () => import(/* webpackChunkName: "about" */ '../views/AfterSale')
}, {/* 联系我们 */
  path: '/contactUs',
  name: 'contactUs',
  component: () => import(/* webpackChunkName: "about" */ '../views/ContactUs')
}, {/* 400电话 */
  path: '/telephone',
  name: 'telephone',
  component: () => import(/* webpackChunkName: "about" */ '../views/Telephone')
}]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

//{
//  path: '/home',
//  name: 'home',
// route level code-splitting - 路由级别代码拆分
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
// 路由级别代码拆分，这将为此路由生成一个单独的块（关于[hash].js），该块在访问路由时被延迟加载。
//  component: () => import(/* webpackChunkName: "home" */ '../views/home.vue')
//}


